export default {
  SET_LOCALE(state, payload) {
    state.locale = payload
  },

  SET_LOCALES(state, payload) {
    state.locales = payload
  },
}
